import React from 'react';

function Contact() {
  return (
    <section id="contact" className="cta-bottom">
      <div>
        <h2>Lass uns starten</h2>
        <p>Du willst echte, nachhaltige Veränderung? Dann lass uns unverbindlich sprechen.<br /><strong>Kostenlos. 30 Minuten. Echte Analyse.</strong></p>
        <p className="contact-line">E-Mail: hello@techsoul-consulting.de</p>
      </div>
      <a href="mailto:hello@techsoul-consulting.de" className="cta-button">E-Mail schreiben</a>
    </section>
  );
}

export default Contact;